module.exports = __webpack_public_path__ + "img/ali_pay@2x.fa0093df.png";